<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form ref="form" lazy-validation style="height: calc(100% - 64px)">
      <v-toolbar flat dark color="primary">
        <v-btn icon @click="handleClickBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-list-item class="px-0">
          <v-list-item-title>
            เลือก Device เพื่อเพิ่มเข้ากลุ่มสิทธิ์
          </v-list-item-title>
        </v-list-item>
      </v-toolbar>
      <div style="height: calc(100% - 128px)">
        <div class="px-4 py-4">
          <label class="body-2">
            การเลือก Device
            <span class="red--text"><strong>*</strong></span>
          </label>
          <v-autocomplete
            class="fix-google-chrome mt-1"
            v-model="selectedAddDeviceType"
            :items="[
              // {
              //   label: 'ทั้งหมด',
              //   value: 'all',
              // },
              {
                label: 'ตามกลุ่ม Device',
                value: 'hardwareGroup',
              },
              {
                label: 'ตามพื้นที่',
                value: 'area',
              },
              {
                label: 'Device',
                value: 'hardware',
              },
            ]"
            :rules="[(v) => !!v || 'โปรดระบุประเภทการเพิ่ม Device']"
            item-text="label"
            item-value="value"
            outlined
            dense
            clearable
            @change="handleSelectedAddDeviceType($event)"
            :loading="loadingSelectedAddDeviceType"
          >
          </v-autocomplete>
        </div>
        <div class="mx-4" style="height: 100%">
          <div class="text-center" v-if="selectedAddDeviceType === 'all'">
            <p class="grey--text" v-if="!loadingSelectedAddDeviceType">
              จำนวน Device ทั้งหมด
              <span class="grey--text text--darken-3"
                >{{ totalHardwares }} Device</span
              >
            </p>
            <p v-else>Loading...</p>
          </div>
          <CardHardwares
            v-if="selectedAddDeviceType === 'hardware'"
            :selectedHardwares="selectedHardwares"
            @onClickBlack="handleClickBack"
            @onCheckHardware="handleCheckHardware"
            @onCheckAllHardware="handleCheckAllHardware"
            @onClearHardwares="selectedHardwares = []"
            @onClearCheckAllHardware="checkedAllHardware = null"
          />
          <CardAreas
            v-if="selectedAddDeviceType === 'area'"
            :selectedHardwares="selectedHardwares"
            @onClickBlack="handleClickBack"
            @onCheckHardware="handleCheckHardware"
            @onCheckAllArea="handleCheckAllArea"
            @onClearHardwares="selectedHardwares = []"
            @onClearArea="selectedArea = null"
          />
          <CardAuthorityHardwareGroup
            v-if="selectedAddDeviceType === 'hardwareGroup'"
            :selectedHardwares="selectedHardwares"
            @onClickBlack="handleClickBack"
            @onCheckHardware="handleCheckHardware"
            @onCheckAllHardwareGroup="handleCheckAllHardwareGroup"
            @onClearHardwares="selectedHardwares = []"
            @onClearHardwareGroup="selectedHardwareGroup = null"
          />
        </div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row class="px-3" justify="start" align="center">
          <v-btn
            :disabled="
              // selectedAddDeviceType !== 'all' &&
              !selectedHardwares.length &&
              selectedHardwareGroup === null &&
              selectedArea === null &&
              checkedAllHardware == null
            "
            class="primary mr-3"
            depressed
            @click="onSave"
            >เพิ่ม Device ที่เลือกเข้ากลุ่มสิทธิ์
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import CardAreas from '@/components/CardAreas.vue'
import CardAuthorityHardwareGroup from '@/components/CardAuthorityHardwareGroup.vue'
import CardHardwares from '@/components/CardHardwares.vue'

export default {
  components: {
    CardAreas,
    CardAuthorityHardwareGroup,
    CardHardwares,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    accessAuthority: {
      type: Object,
    },
    accessAuthorityInit: {
      type: Object,
    },
  },
  data() {
    return {
      loadingSelectedAddDeviceType: false,
      selectedAddDeviceType: null,
      selectedHardwares: [],
      selectedHardwareGroup: null,
      selectedArea: null,
      checkedAllHardware: null,
      searchHardwares: '',
      hardwareAreaFilter: '',
      hardwaresSort: 'hardware_code',
      pagination: {
        currentPage: 1,
        limit: 10,
        isLoading: false,
      },
      hardwaresGroupMember: [],
      totalHardwaresGroupMember: 0,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    lastHardwaresGroupMember() {
      const [lastItem] = this.hardwaresGroupMember.slice(-1)
      return lastItem || {}
    },
    isHardwaresGroupMemberLastPage() {
      return (
        this.pagination.currentPage ===
        Math.ceil(this.totalHardwaresGroupMember / this.pagination.limit)
      )
    },
    hardwaresGroup() {
      return this.$store.state.hardwaresGroup.hardwaresGroup
    },
    totalHardwares() {
      return this.$store.state.hardware.totalHardwares
    },
  },
  methods: {
    ...mapActions({
      addAuthorityDeviceMember: 'accessAuthority/addAuthorityDeviceMember',
      fetchHardwaresGroupMember: 'hardwaresGroup/fetchHardwaresGroupMember',

      fetchAccessAuthority: 'accessAuthority/fetchAccessAuthority',

      fetchHardwares: 'hardware/fetchHardwares',
    }),
    async handleSelectedAddDeviceType(value) {
      if (value === 'all') {
        try {
          this.loadingSelectedAddDeviceType = true

          const { company_uuid } = this.$store.state.authentication.company

          const payload = {
            params: {
              company_uuid,
              dpc: 'access-authority-hardware-to-list-hardware',
              limit: 1,
              offset: 0,
            },
          }

          await this.fetchHardwares(payload)
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.loadingSelectedAddDeviceType = false
        }
      } else {
        this.selectedHardwares = []
      }
    },
    handleCheckHardware(value, hardware) {
      this.selectedHardwares = value
        ? [...this.selectedHardwares, { ...hardware }]
        : this.selectedHardwares.filter(
            (item) => item.hardware_uuid !== hardware.hardware_uuid
          )
    },
    handleCheckAllHardwareGroup(value, hardwareGroup) {
      if (value) {
        this.selectedHardwareGroup = hardwareGroup
        this.selectedHardwares = []
      } else {
        this.selectedHardwareGroup = null
      }
    },
    handleCheckAllArea(value, area) {
      if (value) {
        this.selectedArea = area
        this.selectedHardwares = []
      } else {
        this.selectedArea = null
      }
    },
    handleCheckAllHardware(value, hardware) {
      if (value) {
        this.checkedAllHardware = hardware
        this.selectedHardwares = []
      } else {
        this.checkedAllHardware = null
      }
    },
    handleClickBack() {
      this.$emit('onClickBack')
      this.selectedAddDeviceType = null
      this.selectedHardwares = []
      this.$refs.form.resetValidation()
    },
    async onSave() {
      if (this.$refs.form.validate()) {
        try {
          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          let body = {
            include_all: false,
            hardware_group_uuids: [],
            area_uuids: [],
            hardware_uuids: [],
          }

          // if (this.selectedAddDeviceType === 'all') {
          //   body = {
          //     ...body,
          //     include_all: true,
          //   }
          // }
          if (this.selectedAddDeviceType === 'hardwareGroup') {
            body = {
              ...body,
              hardware_group_uuids: this.selectedHardwareGroup
                ? [this.selectedHardwareGroup]
                : [],
              hardware_uuids: this.selectedHardwareGroup
                ? []
                : this.selectedHardwares.map((item) => item.hardware_uuid),
            }
          }
          if (this.selectedAddDeviceType === 'area') {
            body = {
              ...body,
              area_uuids: this.selectedArea ? [this.selectedArea] : [],
              hardware_uuids: this.selectedArea
                ? []
                : this.selectedHardwares.map((item) => item.hardware_uuid),
            }
          }
          if (this.selectedAddDeviceType === 'hardware') {
            body = {
              ...body,
              include_all: this.checkedAllHardware ? true : false,
              hardware_uuids: this.checkedAllHardware
                ? []
                : this.selectedHardwares.map((item) => item.hardware_uuid),
            }
          }

          const payload = {
            company_uuid,
            authority_uuid: this.accessAuthority.authority_uuid,
            body,
            params: {
              dpc: 'access-authority-hardware-post-delete-to-list-access-authority-hardware',
            },
          }

          await this.addAuthorityDeviceMember(payload)

          const accessAuthority = await this.fetchAccessAuthority({
            company_uuid,
            authority_uuid: this.accessAuthority.authority_uuid,
          })

          this.$store.commit(
            'accessAuthority/EDIT_ACCESS_AUTHORITY',
            accessAuthority
          )

          this.$emit('formActionCompleted', {
            formAction: 'addDevice',
            formType: 'accessAuthorityAddDevice',
            accessAuthority,
          })

          this.$emit('onClickBack')

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 4000,
            message: 'เพิ่มข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.selectedAddDeviceType = null
          this.selectedHardwareGroup = null
          this.selectedArea = null
          this.checkedAllHardware = null
          this.selectedHardwares = []
          this.$refs.form.resetValidation()
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.$store.state.loading = false
        }
      }
    },
    onReset() {
      this.handleClickBack() // TODO: implement reset logic
    },
  },
}
</script>
